
import { Rarity } from "@alienheadwars/football-card-manager-model";
import { motion } from 'framer-motion'; // import motion
import React from "react";

export const rarityGlowColors: Partial<Record<Rarity, string>> = {
    // taken from https://www.color-hex.com/color-palette/38466
    [Rarity.UNCOMMON]: '#1eff00',
    [Rarity.RARE]: '#0070dd',
    [Rarity.EPIC]: '#a335ee',
    [Rarity.LEGENDARY]: '#ff8000',
    [Rarity["GOD-TIER"]]: '#FFD700',
};

interface RarityGlowProps {
    rarity: Rarity,
    style?: React.CSSProperties
}

export const RarityGlow = (props: RarityGlowProps) => {
    const glowColor = rarityGlowColors[props.rarity];

    return <motion.div
        style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 0,
            boxShadow: `0 0 0.1rem 0.1rem ${glowColor}`,
            ...(props.style ??{}),
        }}
    />
}